import React, { useContext } from 'react';
import { Descriptions, Checkbox, Button, Tag } from 'antd';
import { appContext } from "../../AppContext";
import {useFetch} from './../../utils/hooks/useFetch'
import OpenNotification from './../../utils/functions/CreateNotification';

export default function ProfileDescription({
    originalLarper
 }) {

    const [appState] = useContext(appContext);
    const [doFetch] = useFetch();

    const roles = originalLarper.userRoles.map(role => 
            <Tag key={role}>{role}</Tag>
    )

    function clickSendEmailConfirmation() {
        const url = `/api/Account/sendConfirmationEmail?email=${originalLarper.emailAddress}`;

        doFetch(url)
            .then((response) => {
                if(response.isSuccess) {
                    OpenNotification('success', "Email sent")
                    return;
                }
                OpenNotification('error', "Email not sent")
            })
    }

    return (
        <Descriptions title="Profile" bordered>
            {/* <Descriptions.Item label="Name">{name}</Descriptions.Item> */}
            <Descriptions.Item label="Email">{originalLarper.emailAddress}</Descriptions.Item>
            <Descriptions.Item label="Roles">{roles}</Descriptions.Item>
            {originalLarper.isAdmin && <Descriptions.Item label="Admin">
                <Checkbox 
                    checked={originalLarper.isAdmin}
                    disabled 
                />
            </Descriptions.Item> }
            <Descriptions.Item label="Email Confirmed">

                {
                    originalLarper.emailConfirmed ?
                        <Checkbox 
                            checked={originalLarper.emailConfirmed}
                            disabled 
                        /> : appState.user.isAdmin &&
                        <Button onClick={clickSendEmailConfirmation}>
                            Send confirmation email
                        </Button>
                }
            </Descriptions.Item>
            <Descriptions.Item label="Is SL of story">
                <Checkbox 
                    checked={appState.isSlOfStory}
                    disabled 
                />
            </Descriptions.Item>
        </Descriptions>
)
}